exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-date-picker-table .v-btn__content {\n  font-size: 25px !important;\n}\n", ""]);

// exports
